import { Dispatch, SetStateAction } from 'react';

import ChartIcon from '../assets/svg/chart.svg';
import UserIcon from '../assets/svg/user.svg';
import OrderIcon from '../assets/svg/order.svg';
import HelpIcon from '../assets/svg/help.svg';

import './BottomPanel.css';

type BottomPanelProps = {
  activeTab: 'chart' | 'profile' | 'orders' | 'help';
  setActiveTab: Dispatch<SetStateAction<'chart' | 'profile' | 'orders' | 'help'>>;
}

const BottomPanel: React.FC<BottomPanelProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="bottom-panel">
      <button
        className={`bottom-panel__button ${activeTab === 'chart' ? 'bottom-panel__button--active' : ''}`}
        type="button"
        onClick={() => { setActiveTab('chart') }}
      >
        <svg className="icon" width="24" height="24">
          <use href={ChartIcon} />
        </svg>
        Chart
      </button>

      <button
        className={`bottom-panel__button ${activeTab === 'profile' ? 'bottom-panel__button--active' : ''}`}
        type="button"
        onClick={() => { setActiveTab('profile') }}
      >
        <svg className="icon" width="24" height="24">
          <use href={UserIcon} />
        </svg>
        Profile
      </button>

      <button
        className={`bottom-panel__button ${activeTab === 'orders' ? 'bottom-panel__button--active' : ''}`}
        type="button"
        onClick={() => { setActiveTab('orders') }}
      >
        <svg className="icon" width="24" height="24">
          <use href={OrderIcon} />
        </svg>
        Orders
      </button>

      <button
        className={`bottom-panel__button ${activeTab === 'help' ? 'bottom-panel__button--active' : ''}`}
        type="button"
        onClick={() => { setActiveTab('help') }}
      >
        <svg className="icon" width="24" height="24">
          <use href={HelpIcon} />
        </svg>
        Help
      </button>
    </div>
  );
};

export default BottomPanel;
